// returns string telling what relation the int i corresponds to
function whichRelationIsThis(i) {
    switch (i) {
        case 1:
            return "Dual"

        case 2:
            return "Identical";

        case 3:
            return "Chill";

        case 4:
            return "Mirror";

        case 5:
            return "Kindred";

        case 6:
            return "Look-a-like";

        case 7:
            return "Semi-dual";

        case 8:
            return "Illusionary"

        case 9:
            return "Super-ego";

        case 10:
            return "Benifactee";

        case 11:
            return "Benefactor";

        case 12:
            return "Supervisor";

        case 13:
            return "Supervisee";

        case 14:
            return "Q-identity";

        case 15:
            return "Contrary";

        case 16:
            return "Conflict";
        
        default:
            return "";
    }
}

export { whichRelationIsThis }
// case 1:
//             return "Conflict"

//         case 2:
//             return "Identical";

//         case 3:
//             return "Chill";

//         case 4:
//             return "Contrary";

//         case 5:
//             return "Kindred";

//         case 6:
//             return "Look-a-like";

//         case 7:
//             return "Supervisor";

//         case 8:
//             return "Supervisee"

//         case 9:
//             return "Super-ego";

//         case 10:
//             return "Benifactee";

//         case 11:
//             return "Benefactor";

//         case 12:
//             return "Semi-dual";

//         case 13:
//             return "Illusion";

//         case 14:
//             return "Q-identical";

//         case 15:
//             return "Mirror";

//         case 16:
//             return "Dual";
        
//         default:
//             return "";